import { Grid, IconButton } from '@material-ui/core';
import PictureAsPdf from '@material-ui/icons/PictureAsPdf';
import TableChart from '@material-ui/icons/TableChart';
import React from 'react';
import PropTypes from 'prop-types';

export function DownloadReportButton({
  downloadEndOfJobReport,
  downloadEndOfJobReportAsExcel,
}) {
  return (
    <Grid item>
      <IconButton title="Export as PDF" onClick={downloadEndOfJobReport}>
        <PictureAsPdf />
      </IconButton>
      <IconButton
        title="Export as Excel"
        onClick={downloadEndOfJobReportAsExcel}
      >
        <TableChart />
      </IconButton>
    </Grid>
  );
}

DownloadReportButton.propTypes = { downloadEndOfJobReport: PropTypes.func };
